var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['switch', _vm.status ? 'green' : 'red'],on:{"click":_vm.changeStatus}},[_vm._ssrNode("<div"+(_vm._ssrClass(null,['switch_inner', _vm.status ? '' : 'right']))+" data-v-58d567c2>"+_vm._ssrEscape("\n    "+_vm._s(_vm.status ? 'Yes' : 'No')+"\n  ")+"</div>")])
}
var staticRenderFns = []

export { render, staticRenderFns }